import styled from 'styled-components';

const Button = styled.button`
	width: 100%;
	height: 54px;
	font-family: 'Open Sans';
	font-size: 14px;
	font-weight: 600;
	letter-spacing: 1.25px;
	text-align: center;
	outline: 0;
	cursor: pointer;
`;

const CancelButton = styled(Button)`
	border-bottom-left-radius: 4px;
	border-top-width: 1px;
	border-style: solid;
	border-color: #efefef;
	color: #89909b;
	text-decoration: none solid rgb(137, 144, 155);

	&:hover {
		color: #333f4b;
		text-decoration: none solid rgb(51, 63, 75);
	}
`;

const UpdateButton = styled(Button)`
	border: 0;
	border-bottom-right-radius: 4px;
	background-color: #7dba0f;
	color: #ffffff;
	text-decoration: none solid rgb(255, 255, 255);
	opacity: ${props => (props.disabled ? '0.5' : '1')};

	&.disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

export default UpdateButton;
export { CancelButton };
